import type { ProfileConfig } from "@worker/config-schema";
import { el } from "../../lib/dom";
import { widgetShell, fetchWidget, formatCount } from "./base";

type OsuWidget = Extract<ProfileConfig["widgets"][number], { type: "osu" }>;

type OsuData = {
  user: string;
  username?: string;
  avatarUrl?: string;
  rank?: number | null;
  countryRank?: number | null;
  pp?: number;
  accuracy?: number;
  unconfigured?: boolean;
};

export function mountOsuWidget(cfg: OsuWidget): HTMLElement {
  const shell = widgetShell({ kind: "osu", title: "osu!", accent: "#ff66aa" });
  shell.setLoading();

  const controller = new AbortController();
  shell.root.addEventListener("bio:teardown", () => controller.abort());

  const render = async () => {
    const env = await fetchWidget<OsuData>("osu", { u: cfg.username }, { signal: controller.signal });
    if (!env.ok || !env.data) return shell.setError(env.error ?? "unavailable");
    const d = env.data;
    if (d.unconfigured) return shell.setError("requires OSU_CLIENT_ID + SECRET");
    shell.body.innerHTML = "";
    const row = el("div", { class: "widget-osu__row" });
    if (d.avatarUrl) {
      row.append(el("img", { class: "widget-osu__avatar", src: d.avatarUrl, alt: "", draggable: false }));
    }
    const info = el("div", { class: "widget-osu__info" });
    info.append(el("div", { class: "widget-osu__name" }, [d.username ?? cfg.username]));
    info.append(
      el("div", { class: "widget-osu__stats" }, [
        d.rank ? `#${formatCount(d.rank)} ` : "unranked ",
        "· ",
        d.pp ? `${formatCount(d.pp)} pp` : "",
      ]),
    );
    row.append(info);
    shell.body.append(row);
  };

  void render();
  const interval = window.setInterval(render, 3 * 60_000);
  shell.root.addEventListener("bio:teardown", () => window.clearInterval(interval));

  return shell.root;
}
